/* Shopify's native consent dialog. No consent is granted by this control. */
document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[data-bf-cookie-preferences]');
  if (!trigger) return;
  const status = document.getElementById('bf-cookie-preferences-status');
  if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
    window.privacyBanner.showPreferences().catch(function () {
      if (status) status.textContent = 'Die Cookie-Einstellungen konnten nicht geladen werden. Bitte lade die Seite erneut.';
    });
  } else if (status) {
    status.textContent = 'Die Cookie-Einstellungen werden geladen. Bitte versuche es gleich erneut.';
  }
});
